import { useEffect, useState } from 'react';
import { FeedLinkDto } from '@/api/feed';
import { PhotoPickerFile } from '@/components/common/photo-picker';

interface UseFeedFormProps {
  initialPhotos?: PhotoPickerFile[];
  initialCaption?: string;
  initialLinks?: FeedLinkDto[];
}

interface UseFeedFormReturn {
  photos: PhotoPickerFile[];
  setPhotos: (photos: PhotoPickerFile[]) => void;
  caption: string;
  setCaption: (caption: string) => void;
  links: FeedLinkDto[];
  setLinks: (links: FeedLinkDto[]) => void;
  isDirty: boolean;
  setIsDirty: (isDirty: boolean) => void;
  isValid: boolean;
}

/**
 * Custom hook to manage feeds form state
 */
export const useFeedForm = ({
  initialPhotos = [],
  initialCaption = '',
  initialLinks = [],
}: UseFeedFormProps = {}): UseFeedFormReturn => {
  const [photos, setPhotos] = useState<PhotoPickerFile[]>(initialPhotos);
  const [caption, setCaption] = useState<string>(initialCaption);
  const [links, setLinks] = useState<FeedLinkDto[]>(initialLinks);
  const [isDirty, setIsDirty] = useState<boolean>(true);

  useEffect(() => {
    setPhotos(initialPhotos);
    setCaption(initialCaption);
    setLinks(initialLinks);
  }, [initialPhotos, initialCaption, initialLinks]);

  // Validate form data
  const isValid = photos.length > 0;

  return {
    photos,
    setPhotos,
    caption,
    setCaption,
    links,
    setLinks,
    isDirty,
    setIsDirty,
    isValid,
  };
};